import toast from "react-hot-toast";
import { setToken } from "../../utils/tokens";
import api from "../axiosInstance";

export const SigninAPI = (payload) => async (dispatch) => {
  try {
    const response = await api.post("admin/login", payload);
    dispatch({ type: "LOGIN", payload: response.data });
    setToken(response.data);
    return response.data;
  } catch (error) {
    console.log("Error:", error);
    if (error && error.response.data.error.statusCode === 400) {
      toast.error("Incorrect Email or password");
    } else {
      toast.error("Something went wrong");
    }
  }
};

export const AdminProfileAPI = (payload) => async (dispatch) => {
  try {
    const response = await api.get(`admin/`);
    dispatch({
      type: "ADMIN_PROFILE",
      payload: response.data,
    });
    return response;
  } catch (err) {
    console.log(err);
  }
};

export const Logout = async () => {
  const refreshToken = localStorage.getItem("tykoon_refresh");
  const response = await api.post(`/admin/logout`, {
    refreshToken: JSON.parse(refreshToken),
  });
  return response;
};
